import { Component } from '@angular/core';
import { Offcanvas } from '@app/modules/offcanvas/offcanvas.module';
import { faCircleQuestion, IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'fdx-cheat-sheet-offcanvas',
    templateUrl: './cheat-sheet-offcanvas.component.html',
    styleUrl: './cheat-sheet-offcanvas.component.scss',
    standalone: false
})
export class CheatSheetOffcanvasComponent implements Offcanvas {

    public readonly title: string = 'FQL cheat sheet';
    public readonly icon: IconDefinition = faCircleQuestion;

    constructor(
        private offcanvas: NgbActiveOffcanvas
    ) { }

    public onOffcanvasInit(): void {
        // do nothing
    }

    public onOffcanvasDismissed(reason: any): void {
        this.offcanvas.dismiss(reason);
    }
}
